<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="700"
  >
    <a-form :model="formState" :rules="rules" ref="formRef">
      <div class="df both-side">
        <a-form-item label="部件名称" name="name">
          <a-input
            v-model:value="formState.name"
            placeholder="请输入部件名称"
            style="width: 230px"
          ></a-input>
        </a-form-item>

        <a-form-item label="部件编码" name="materialCode">
          <a-input
            v-model:value="formState.materialCode"
            placeholder="请输入部件编码"
            style="width: 215px"
          ></a-input>
        </a-form-item>
      </div>

      <div class="df both-side">
        <a-form-item label="SN号" name="snNumber">
          <a-input
            v-model:value="formState.snNumber"
            placeholder="请输入SN号"
            style="width: 260px"
            auto-size
          ></a-input>
        </a-form-item>
        <a-form-item label="物料批号" name="materialBatch">
          <a-input
            v-model:value="formState.materialBatch"
            placeholder="请输入物料批号"
            style="width: 215px"
            auto-size
          ></a-input>
        </a-form-item>
      </div>

      <div class="df both-side">
        <a-form-item label="需求日期" name="demandDate">
          <a-date-picker
            v-model:value="formState.demandDate"
            style="width: 240px"
          ></a-date-picker>
        </a-form-item>
        <a-form-item label="线上数量" name="onlineNumber">
          <a-input-number
            v-model:value="formState.onlineNumber"
            placeholder="请输入线上数量"
            style="width: 215px"
            auto-size
          ></a-input-number>
        </a-form-item>
      </div>

      <div class="df both-side">
        <a-form-item label="需求数量" name="demandNumber">
          <a-input-number
            v-model:value="formState.demandNumber"
            style="width: 240px"
            placeholder="请输入需求数量"
            auto-size
          ></a-input-number>
        </a-form-item>
        <a-form-item label="缺货状态" name="shortage">
          <a-select
            v-model:value="formState.shortage"
            placeholder="请选择缺货状态"
            style="width: 215px"
            allowClear
          >
            <a-select-option value="缺货">缺货</a-select-option>
            <a-select-option value="正常">正常</a-select-option>
          </a-select>
        </a-form-item>
      </div>

      <a-form-item label="供应商发货日期" name="supplierDeliveryDate">
        <a-date-picker
          v-model:value="formState.supplierDeliveryDate"
          style="width: 200px"
        ></a-date-picker>
      </a-form-item>
      <a-form-item label="备注">
        <content-dsc-vue :question="formState.notes" ref="notesRef">
        </content-dsc-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import { showUploading, hideUploading } from "@/utils/index";
import {
  saveOrUpdateMaterialShortage,
  uploadProduceAttachment,
} from "@/request/view/product";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import contentDscVue from "@/views/productDaily/components/quality/components/question.vue";

export default defineComponent({
  components: { uploadImgVue, uploadVideoVue, contentDscVue },
  props: {
    type: String,
  },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });
    const imgRef = ref();
    const videoRef = ref();

    const notesRef = ref();

    const formState = reactive({
      id: null,
      demandDate: null,
      demandNumber: null,
      shortage: null,
      localDate: null,
      materialBatch: null,
      materialCode: null,
      supplierDeliveryDate: null,
      name: null,
      notes: null,
      onlineNumber: null,
      type: null,
      snNumber: null,
      project: "swan",
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {
      name: [
        {
          required: true,
          message: "请输入名称/编码",
          trigger: "blur",
          type: "string",
        },
      ],
      // materialBatch: [
      //   {
      //     required: true,
      //     message: "请输入物料批号",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // snNumber: [
      //   {
      //     required: true,
      //     message: "请输入SN号",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // onlineNumber: [
      //   {
      //     required: true,
      //     message: "请输入线上数量",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // demandNumber: [
      //   {
      //     required: true,
      //     message: "请输入需求数量",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
      // demandDate: [
      //   {
      //     required: true,
      //     message: "请输入需求日期",
      //     trigger: "change",
      //     type: "any",
      //   },
      // ],
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addMaterialShortage") {
        modalConfig.title = "添加物料缺货情况";
        formState.localDate = timeStampToTime("", "upload");
        const { id, username } = store.state.user.user;
        formState.userId = id;
        formState.username = username;
        formState.type = props.type;
        formState.project = "swan";
        formState.shortage = "缺货";
      } else if (type === "editMaterialShortage") {
        modalConfig.title = "编辑物料缺货情况";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            showUploading();
            await notesRef.value
              .uploadFile()
              .then((res) => {
                formState.notes = JSON.stringify(res);
              })
              .catch((err) => {
                hideUploading();
              });

            await saveOrUpdateMaterialShortage(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
                hideUploading();
              })
              .catch((err) => {
                console.log(err);
                hideUploading();
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      notesRef,
      rules,
      isEdit,
      imgRef,
      videoRef,
      uploadProduceAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
